module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "album-track-item relative",
    class: {
      selected: _vm.buttonHover ||
        (_vm.isPlaying && _vm.trackIndex == _vm.$store.state.player.trackIndex) ||
        (!_vm.isPlaying && _vm.trackIndex == 0),
    },
    on: {
      "click": function($event) {
        _vm.selectTrack()
      },
      "mouseenter": function($event) {
        _vm.buttonHover = true
      },
      "mouseleave": function($event) {
        _vm.buttonHover = false
      }
    }
  }, [(
    false &&
    (!_vm.currentUser || (_vm.currentUser && _vm.album.user.id != _vm.currentUser.id))
  ) ? _c('v-btn', {
    staticClass: "action-btn"
  }, [(_vm.trackIndex == _vm.$store.state.player.trackIndex && _vm.isPlaying) ? _c('v-icon', [_vm._v("pause")]) : (_vm.buttonHover || (_vm.trackIndex == 0 && !_vm.isPlaying)) ? _c('v-icon', [_vm._v("play_arrow")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "track-name"
  }, [(_vm.showIndexPlayIcon && (_vm.trackIndex == _vm.$store.state.player.trackIndex && _vm.isPlaying)) ? _c('img', {
    staticClass: "track-showIndexPlayIcon",
    attrs: {
      "width": "15",
      "src": "/static/images/graph-bar.svg"
    }
  }) : _c('span', {
    staticClass: "track-index"
  }, [_vm._v(_vm._s(_vm.trackIndex + 1) + ". ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.track.name))]), _vm._v(" "), (_vm.album.album_type == 'playlist') ? _c('router-link', {
    staticClass: "track-user-name",
    attrs: {
      "to": ("/" + (_vm.track.user.slug))
    }
  }, [_vm._v("\n      - " + _vm._s(_vm.track.user.username))]) : _vm._e()], 1), _vm._v(" "), (!_vm.hideMoreBtn) ? _c('div', {
    staticClass: "right-section",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(
    _vm.buttonHover &&
    !(_vm.trackIndex == _vm.$store.state.player.trackIndex && _vm.isPlaying)
  ) ? _c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("play_arrow")]) : _vm._e(), _vm._v(" "), (!_vm.showIndexPlayIcon && _vm.selectedTrackIsPlaying) ? _c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("pause")]) : _vm._e(), _vm._v(" "), _c('v-menu', {
    staticClass: "track-more-action",
    attrs: {
      "offset-y": "",
      "close-on-content-click": false
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-btn', {
    staticClass: "more-btn",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [(
    _vm.album.album_type == 'playlist' &&
    _vm.currentUser &&
    _vm.album.user.id == _vm.currentUser.id
  ) ? _c('v-list-tile', {
    key: "remove_track",
    nativeOn: {
      "click": function($event) {
        _vm.removeItem()
      }
    }
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item"
  }, [_c('label', [_vm._v("Remove Track")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    key: "share",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.showShareDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("Share")])])], 1), _vm._v(" "), (false && _vm.album.album_type != 'playlist') ? _c('v-list-tile', {
    key: "add_to_playlist",
    staticClass: "default-menu-item track-menu-item has-sub-menu"
  }, [_c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-x": ""
    },
    model: {
      value: (_vm.submenu),
      callback: function($$v) {
        _vm.submenu = $$v
      },
      expression: "submenu"
    }
  }, [_c('v-list-tile-title', {
    staticClass: "has-sub-menu",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "track-status-icon",
    attrs: {
      "src": "/static/images/ic_add_to.png"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Add to Playlist")])]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    key: "add_to_playlist",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.addToNewPlaylist()
      }
    }
  }, [_c('v-dialog', {
    staticClass: "playlist-dialog",
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.playlist_dialog),
      callback: function($$v) {
        _vm.playlist_dialog = $$v
      },
      expression: "playlist_dialog"
    }
  }, [_c('v-list-tile-title', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "track-status-icon",
    attrs: {
      "src": "/static/images/ic_add_to.png"
    }
  }), _vm._v(" "), _c('label', [_vm._v("New Playlist")])]), _vm._v(" "), _c('v-card', {
    staticClass: "playlist-dialog-body"
  }, [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('h5', {
    staticClass: "ma-0"
  }, [_vm._v("New Playlist")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "dialog-close-btn",
    nativeOn: {
      "click": function($event) {
        _vm.playlist_dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("highlight_off")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "create-playlist-section"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Name"), _c('label', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.playlist.name),
      expression: "playlist.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.playlist.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.playlist, "name", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "create-playlist-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.createPlaylist()
      }
    }
  }, [_vm._v("Create Playlist")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.playlists), function(list, list_index) {
    return _c('v-list-tile', {
      key: ("playlist_1_" + list_index),
      staticClass: "default-menu-item track-menu-item",
      nativeOn: {
        "click": function($event) {
          _vm.addToPlaylist(list)
        }
      }
    }, [_c('v-list-tile-title', [_c('img', {
      staticClass: "track-status-icon",
      attrs: {
        "src": "/static/images/ic_download.png"
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(list.name))])])], 1)
  })], 2)], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showStats) ? _c('div', {
    staticClass: "track-actions"
  }, [_c('v-btn', {
    staticClass: "action-btn"
  }, [_c('v-icon', [_vm._v("play_arrow")]), _vm._v(_vm._s(_vm.track.played))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.share_dialog) ? _c('share-modal', {
    attrs: {
      "item": _vm.album,
      "dismiss": _vm.dismissShareDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cba492e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/albumtrackitem.vue
// module id = 1666
// module chunks = 180